import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: resolve => require(["../views/Home.vue"], resolve),
    //meta: { title: "服务通", keepAlive: true}
    meta: { title: "服务通"}
  },
  {
    path: "/login",
    component: resolve => require(["../views/login.vue"], resolve),
    meta: { title: "登录中" }
  },
  {
    path: "/callback",
    component: resolve => require(["../views/Callback.vue"], resolve),
    meta: { title: "登录中" }
  },
  
  {
    path: "/CallRequest/List",
    component: resolve =>
      require(["../views/CallRequest/list.vue"], resolve),
    meta: { title: "叫修记录"},
    
  },
  {
    path: "/CallRequest/detail",
    component: resolve =>
      require(["../views/CallRequest/detail.vue"], resolve),
    meta: { title: "叫修详情"},
    
  },
  {
    path: "/Maintenance/List",
    component: resolve =>
      require(["../views/Maintenance/list.vue"], resolve),
    meta: { title: "巡保记录"},
    
  },
  {
    path: "/Maintenance/detail",
    component: resolve =>
      require(["../views/Maintenance/detail.vue"], resolve),
    meta: { title: "巡保详情"},
  },
  {
    path: "/Complaint/List",
    component: resolve =>
      require(["../views/Complaint/list.vue"], resolve),
    meta: { title: "投诉列表"},
    
  },
  {
    path: "/Complaint/detail",
    component: resolve =>
      require(["../views/Complaint/detail.vue"], resolve),
    meta: { title: "意见详情"},
  },
  
]

const router = new VueRouter({
  routes
})

export default router
